import React from "react";
import PropTypes from "prop-types"
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import $ from "jquery";
import ImageUploaderView from "./ImageUploaderView";
import InputHelpers from "../../utils/InputHelpers";
import PrivateSpaceCardDetailsGoogleMapView from "./PrivateSpaceCardDetailsGoogleMapView";


class SpaceEditView extends React.Component {

    static propTypes = {
        isSaving: PropTypes.bool.isRequired,
        googleAPILibReady: PropTypes.bool.isRequired,
        isLimitedEdit: PropTypes.bool.isRequired,
        title: PropTypes.object.isRequired,
        description: PropTypes.object.isRequired,
        price: PropTypes.object.isRequired,
        minimumDays: PropTypes.object.isRequired,
        spaceAddressGooglePlaceId: PropTypes.object.isRequired,
        spaceAddressLatitude: PropTypes.number.isRequired,
        spaceAddressLongitude: PropTypes.number.isRequired,
        spaceAddress: PropTypes.string.isRequired,
        spaceId: PropTypes.number.isRequired,
        showingImageSlideIndex: PropTypes.number.isRequired,
        imageNames: PropTypes.arrayOf(PropTypes.string).isRequired,
        uploadPercentage: PropTypes.number.isRequired,
        isDirtyImages: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);
        this.autocomplete = null;
        this.formSubmitRef = React.createRef();
    }

    componentDidMount() {
        const elem = document.getElementById("inputSpaceAddress");
        if (elem !== null && this.props.googleAPILibReady) {
            this.attachGoogleAPI(elem)
        }
        $('[data-toggle="tooltip"]').tooltip()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const elem = document.getElementById("inputSpaceAddress");
        if (elem !== null && this.props.googleAPILibReady) {
            this.attachGoogleAPI(elem)
        }
    }

    componentWillUnmount() {
        const elem = document.getElementById("inputSpaceAddress");
        if (elem !== null && this.props.googleAPILibReady) {
            window.google.maps.event.removeListener(this.autocompleteEventListener);
        }
        if (elem !== null) {
            elem.remove()
        }
    }

    attachGoogleAPI(elem) {
        this.autocomplete =
            new window.google.maps.places.Autocomplete(elem, {});
        this.autocomplete.setFields(["geometry", "place_id"]);
        this.autocompleteEventListener =
            this.autocomplete.addListener(
                "place_changed",
                () => {
                    const elem = document.getElementById("inputSpaceAddress");
                    const isValid =
                        this.autocomplete.getPlace() !== undefined &&
                        this.autocomplete.getPlace().place_id !== undefined &&
                        this.autocomplete.getPlace().geometry !== undefined &&
                        this.autocomplete.getPlace().geometry.location !== undefined &&
                        this.autocomplete.getPlace().geometry.location.lat() !== undefined &&
                        this.autocomplete.getPlace().geometry.location.lng() !== undefined;

                    if (isValid) {
                        elem.setCustomValidity("");
                        EventPublisher.publish(
                            UIInteractionEvents.SPACE_EDIT_ADDRESS_AUTOCOMPLETE_CHANGED,
                            {
                                "address": elem.value,
                                "placeId": this.autocomplete.getPlace().place_id,
                                "latitude": this.autocomplete.getPlace().geometry.location.lat(),
                                "longitude": this.autocomplete.getPlace().geometry.location.lng(),
                                "isValid": true
                            });
                    } else {
                        elem.setCustomValidity("Requires a valid location");
                        if (this.props.spaceAddressGooglePlaceId.isValid) {
                            EventPublisher.publish(
                                UIInteractionEvents.SPACE_EDIT_ADDRESS_AUTOCOMPLETE_CLEARED,
                                {}
                            );
                        }
                    }
                });
    }

    handleTitleChanged = (event) => {
        this.cursor = event.target.selectionStart;
        EventPublisher.publish(
            UIInteractionEvents.SPACE_EDIT_TITLE_CHANGED,
            {
                title: event.target.value,
                isValid: event.target.checkValidity()
            });
    };

    handleDescriptionChanged = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.SPACE_EDIT_DESCRIPTION_CHANGED,
            {
                description: event.target.value,
                isValid: event.target.checkValidity()
            });
    };

    handlePriceChanged = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.SPACE_EDIT_PRICE_CHANGED,
            {
                price:  event.target.value,
                isValid: event.target.checkValidity()
            });
    };

    handleMinimumDaysChanged = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.SPACE_EDIT_MINIMUM_DAYS_CHANGED,
            {
                minimumDays: event.target.value,
                isValid: event.target.checkValidity()
            });
    };

    handleFormSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.everythingIsValidAndDirty()) {
            EventPublisher.publish(
                UIInteractionEvents.SPACE_EDIT_SAVE_SUBMITTED,
                {
                    title: this.props.title.currentValue,
                    description: this.props.description.currentValue,
                    price: this.props.price.currentValue,
                    minimumDays: this.props.minimumDays.currentValue,
                    spaceAddressGooglePlaceId: this.props.spaceAddressGooglePlaceId.currentValue,
                    spaceAddressLatitude: this.props.spaceAddressLatitude,
                    spaceAddressLongitude: this.props.spaceAddressLongitude,
                    spaceAddress: this.props.spaceAddress,
                    spaceId: this.props.spaceId,
                    imageNames: this.props.imageNames
                }
            );
        }
    };

    handleCancelClicked = (event) => {
        event.preventDefault();
        event.stopPropagation();
        EventPublisher.publish(UIInteractionEvents.MY_SPACES_BUTTON_CLICK, {});
    };

    everythingIsValidAndDirty() {
        return this.props.title.isValid &&
            this.props.description.isValid &&
            this.props.price.isValid &&
            this.props.minimumDays.isValid &&
            this.props.spaceAddressGooglePlaceId.isValid &&
            (this.props.title.isTouched ||
                this.props.description.isTouched ||
                this.props.price.isTouched ||
                this.props.minimumDays.isTouched ||
                this.props.spaceAddressGooglePlaceId.isTouched ||
                this.props.isDirtyImages)
    }

    generateClassNameWithValidityForFormFieldWithValidState(defaultClassName, formFieldWithValidityState) {
        if (formFieldWithValidityState.isTouched && formFieldWithValidityState.isValid) {
            return defaultClassName+" is-valid";
        } else if (formFieldWithValidityState.isTouched && !formFieldWithValidityState.isValid) {
            return defaultClassName+" is-invalid";
        }
        return defaultClassName;
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-box">
                                <span className="align-middle">
                                    Edit your Space
                                </span>
                                <span className="ml-auto float-right">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={this.handleCancelClicked}
                                    >
                                        Cancel
                                    </button>
                                </span>
                            </div>
                            <div className="card-body">
                                <form ref={this.formSubmitRef} noValidate>
                                    <div className="form-group">
                                        <label htmlFor="inputTitle">Title</label>
                                        <div className={this.generateClassNameWithValidityForFormFieldWithValidState("input-group flex-nowrap", this.props.title)}>
                                            <input
                                                type="text"
                                                className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control", this.props.title)}
                                                id="inputTitle"
                                                placeholder="title"
                                                defaultValue={this.props.title.currentValue}
                                                onChange={this.handleTitleChanged}
                                                required={true}
                                                pattern=".{5,}"
                                                disabled={this.props.isSaving}/>
                                            <div className="input-group-append">
                                                <span
                                                    className="input-group-text"
                                                    id="addon-wrapping"
                                                    data-toggle="tooltip"
                                                    data-placement="bottom"
                                                    title="Required">
                                                    <i className="fas fa-exclamation-circle text-warning"/>
                                                </span>
                                            </div>
                                        </div>
                                        <small id="titleHelpBlock" className="form-text text-muted">
                                            Briefly describe what this Space is. Consider adding information
                                            about the <strong className="text-cuvered-pink">medium</strong> (ex. Wall
                                            Hanging) and the <strong className="text-cuvered-pink">domain
                                            </strong> (ex. Coffee Shop Door.).
                                        </small>
                                        <div className="valid-feedback">
                                            Looks good!
                                        </div>
                                        <div className="invalid-feedback">
                                            Please enter valid title. Title must be greater than 5 characters.
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputPrice">Price per day</label>
                                            <div className={this.generateClassNameWithValidityForFormFieldWithValidState("input-group flex-nowrap", this.props.price)}>
                                                <input
                                                    type="number"
                                                    className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control", this.props.price)}
                                                    id="inputPrice"
                                                    min="0.01"
                                                    step="0.01"
                                                    pattern="^\d*(\.\d{0,2})?$"
                                                    defaultValue={this.props.price.currentValue}
                                                    onChange={this.handlePriceChanged}
                                                    required={true}
                                                    disabled={this.props.isSaving || this.props.isLimitedEdit}/>
                                                <div className="input-group-append">
                                                    <span
                                                        className="input-group-text"
                                                        id="addon-wrapping"
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Required">
                                                        <i className="fas fa-exclamation-circle text-warning"/>
                                                    </span>
                                                </div>
                                            </div>
                                            <small id="ppdHelpBlock" className="form-text text-muted">
                                                How much would are you charging for a single day of hosting an
                                                advertisement in this space?  <strong className="text-cuvered-pink">
                                                Cuvered takes 10% as it's fee - take this into account with your
                                                pricing.</strong>
                                            </small>
                                            <div className="valid-feedback">
                                                Looks good!
                                            </div>
                                            <div className="invalid-feedback">
                                                Please enter valid price. Price has to be greater than zero per day and have no more than two decimal places.
                                            </div>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputPhoneNumber">Minimum Days</label>
                                            <div className={this.generateClassNameWithValidityForFormFieldWithValidState("input-group flex-nowrap", this.props.minimumDays)}>
                                                <input
                                                    type="number"
                                                    id="inputMinimumDays"
                                                    required={true}
                                                    className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control w-100", this.props.minimumDays)}
                                                    min="1"
                                                    defaultValue={this.props.minimumDays.currentValue}
                                                    onChange={this.handleMinimumDaysChanged}
                                                    disabled={this.props.isSaving || this.props.isLimitedEdit}/>
                                                <div className="input-group-append">
                                                    <span
                                                        className="input-group-text"
                                                        id="addon-wrapping"
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Required">
                                                        <i className="fas fa-exclamation-circle text-warning"/>
                                                    </span>
                                                </div>
                                            </div>
                                            <small id="minimumDaysHelpBlock" className="form-text text-muted">
                                                Minimum days required to book space.  In other words, how often are
                                                you willing to switch out the Advertisement?
                                            </small>
                                            <div className="valid-feedback">
                                                Looks good!
                                            </div>
                                            <div className="invalid-feedback">
                                                Please enter valid number of minimum days. Number has to be greater than zero.
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.generateClassNameWithValidityForFormFieldWithValidState("form-group", this.props.description)}>
                                        <label htmlFor="inputAbout">Description</label>
                                        <textarea
                                            className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control", this.props.description)}
                                            id="inputDescription"
                                            rows="10"
                                            defaultValue={this.props.description.currentValue}
                                            onChange={this.handleDescriptionChanged}
                                            disabled={this.props.isSaving}/>
                                        <small id="aboutHelpBlock" className="form-text text-muted">
                                            Describe your Space to entice Advertisers to use it.  The first 100 or so
                                            characters will be used as the snippet on the search page, so say something
                                            to draw them in.  We advise that, if they are applicable, you describe 3
                                            elements of your space:  The <strong className="text-cuvered-pink">medium
                                            </strong> you are offering for rent and any applicable restrictions (ex. A
                                            wall hanging of up to 3x5 feet), the <strong className="text-cuvered-pink">
                                            demographics</strong> of people that are generally exposed to your space
                                            (ex. Mostly students in their 20's), and the
                                            <strong className="text-cuvered-pink"> rough volume </strong> of traffic
                                            that is generally exposed to your space.
                                        </small>
                                    </div>
                                    <ImageUploaderView
                                        isDisabled={this.props.isSaving}
                                        showingImageSlideIndex={this.props.showingImageSlideIndex}
                                        imageNames={this.props.imageNames}
                                        uploadPercentage={this.props.uploadPercentage}
                                        labelName={"Space Images"}
                                    />
                                    <div className="form-group">
                                        <label htmlFor="inputSpaceAddress">Space Address</label>
                                        <div className={this.generateClassNameWithValidityForFormFieldWithValidState("input-group flex-nowrap", this.props.spaceAddressGooglePlaceId)} >
                                            <input
                                                type="text"
                                                className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control", this.props.spaceAddressGooglePlaceId)}
                                                id="inputSpaceAddress"
                                                placeholder={this.props.googleAPILibReady ? "123 Sesame Street, Kings Park, NY, USA" : "Loading Google API"}
                                                required={true}
                                                readOnly={!this.props.googleAPILibReady}
                                                defaultValue={this.props.spaceAddress}
                                                disabled={this.props.isSaving || this.props.isLimitedEdit}
                                                onFocus={InputHelpers.onFocusBrowserAutoFillDisabled}
                                            />
                                            <div className="input-group-append">
                                                    <span
                                                        className="input-group-text"
                                                        id="addon-wrapping"
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Required">
                                                        <i className="fas fa-exclamation-circle text-warning"/>
                                                    </span>
                                            </div>
                                        </div>
                                        <small id="paymentAddressHelpBlock" className="form-text text-muted">
                                            What is the address of the space?
                                        </small>
                                    </div>
                                    <div className="mb-3">
                                        {this.renderLocationMap()}
                                    </div>
                                    <button
                                        type="submit"
                                        className={this.everythingIsValidAndDirty() ? "btn btn-primary" : "btn btn-danger"}
                                        onClick={this.handleFormSubmit}
                                        disabled={this.props.isSaving || !this.everythingIsValidAndDirty()}>
                                        {
                                            this.props.isSaving ?
                                                (
                                                    <span>
                                                        <span className="spinner-border spinner-border-sm mr-2"/>
                                                        Saving
                                                    </span>
                                                ) :
                                                "Submit"
                                        }
                                    </button>
                                    <span className="ml-2">
                                        {
                                            !this.everythingIsValidAndDirty() ?
                                                (
                                                    <span className="alert alert-danger">
                                                        <i className="fas fa-exclamation-triangle mr-2"/>
                                                        Please fill out all required fields and correct any validation errors before proceeding.
                                                    </span>
                                                ):
                                                null
                                        }
                                    </span>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderLocationMap() {
        if (this.props.spaceAddressGooglePlaceId.isValid) {
            return (
                <PrivateSpaceCardDetailsGoogleMapView
                    latitude={this.props.spaceAddressLatitude}
                    longitude={this.props.spaceAddressLongitude}
                    disableDefaultUI={false}
                />
            );
        }
        return (
            <div/>
        );
    }

}

export default SpaceEditView;